module.exports = __webpack_public_path__ + "static/media/shower2.6059bcf6.gif";